import { render, staticRenderFns } from "./RegisterRefoundAudit.vue?vue&type=template&id=2d8990d5&scoped=true&"
import script from "./RegisterRefoundAudit.vue?vue&type=script&lang=js&"
export * from "./RegisterRefoundAudit.vue?vue&type=script&lang=js&"
import style0 from "./RegisterRefoundAudit.vue?vue&type=style&index=0&id=2d8990d5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8990d5",
  null
  
)

export default component.exports